import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Table, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEv_list, addEv, removeEv } from '../../store';
import axios from 'axios';
import config from '../../config';
import './EnvironmentSetting.css';

function EnvironmentSetting() {
  const dispatch = useDispatch();
  const Ev_list = useSelector((state) => state.Ev_list || {});
  const evData = useSelector((state) => state.evData || {});

  const settingList = useSelector((state) => state.settingList || {});
  
  const [inputcommPort, setcommPort] = useState('RS485-CH1');
  const [inputAddress, setInputAddress] = useState('1');
  const [inputName, setInputName] = useState('엠알티표준-1');
  const [inputProtocol, setInputProtocol] = useState('엠알티-Modbus');
  const [inputEthernetIp, setInputEthernetIp] = useState('192.168.0.101');
  const [inputEthernetPort, setInputEthernetPort] = useState('8080');
  const [showModal, setShowModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const [temperatureTypes, setTemperatureTypes] = useState([]);
  const [sunTypes, setSunTypes] = useState([]);

  const { commPortList = [], sensor_protocolList = [] } = settingList;

  useEffect(() => {
    dispatch(fetchEv_list());
  }, [dispatch]);

  useEffect(() => {
    if (Ev_list.seq) {
      setTemperatureTypes(Ev_list.seq.map((_, index) => Ev_list.ev_temperatureType[index]));
      setSunTypes(Ev_list.seq.map((_, index) => Ev_list.ev_sunType[index]));
    }
  }, [Ev_list]);

  // 온도 타입 체크박스 선택 시 즉시 DB에 저장 및 크로스 기능 구현
  const handleTemperatureChange = async (index, value) => {
    const updatedTemperatureTypes = [...temperatureTypes];

    // 온도 타입끼리 크로스 (같은 값이 이미 선택되어 있으면 반대 값으로 설정)
    Ev_list.seq.forEach((seq, i) => {
      if (i !== index && updatedTemperatureTypes[i] === value) {
        updatedTemperatureTypes[i] = value === 0 ? 1 : 0; // 값 크로스
      }
    });

    updatedTemperatureTypes[index] = value;
    setTemperatureTypes(updatedTemperatureTypes);

    // 크로스된 값도 DB에 저장
    await updateEvTemperatureAndSunTypes(index, updatedTemperatureTypes[index], sunTypes[index]);
    Ev_list.seq.forEach((seq, i) => {
      if (i !== index) {
        updateEvTemperatureAndSunTypes(i, updatedTemperatureTypes[i], sunTypes[i]);
      }
    });

    // 저장 완료 알림창 표시
    alert('저장되었습니다.');
  };

  // 일사량 타입 체크박스 선택 시 즉시 DB에 저장 및 크로스 기능 구현
  const handleSunTypeChange = async (index, value) => {
    const updatedSunTypes = [...sunTypes];

    // 일사량 타입끼리 크로스 (같은 값이 이미 선택되어 있으면 반대 값으로 설정)
    Ev_list.seq.forEach((seq, i) => {
      if (i !== index && updatedSunTypes[i] === value) {
        updatedSunTypes[i] = value === 0 ? 1 : 0; // 값 크로스
      }
    });

    updatedSunTypes[index] = value;
    setSunTypes(updatedSunTypes);

    // 크로스된 값도 DB에 저장
    await updateEvTemperatureAndSunTypes(index, temperatureTypes[index], updatedSunTypes[index]);
    Ev_list.seq.forEach((seq, i) => {
      if (i !== index) {
        updateEvTemperatureAndSunTypes(i, temperatureTypes[i], updatedSunTypes[i]);
      }
    });

    // 저장 완료 알림창 표시
    alert('저장되었습니다.');
  };


  // DB 업데이트 함수 (온도 타입과 일사량 타입)
  const updateEvTemperatureAndSunTypes = async (index, temperatureType, sunType) => {
    const updatedEv = {
      commPort: Ev_list.ev_commPort[index],
      address: Ev_list.ev_address[index],
      name: Ev_list.ev_name[index],
      protocol: Ev_list.ev_protocol[index],
      ethernetIp: Ev_list.ev_ethernetIp[index],
      ethernetPort: Ev_list.ev_ethernetPort[index],
      ev_temperatureType: temperatureType,
      ev_sunType: sunType,
    };

    try {
      const response = await axios.put(`${config.backendUrl}/api/update_ev/${Ev_list.seq[index]}`, updatedEv);
      if (response.status === 200) {
        console.log(`장비 ${index + 1} 업데이트 완료`);
      } else {
        console.error(`장비 ${index + 1} 업데이트 실패:`, response);
      }
    } catch (error) {
      console.error(`장비 ${index + 1} 업데이트 중 오류 발생:`, error);
    }
  };

  // 센서 추가 (처음 로직으로 복원)
  const evAddClick = async () => {
    // 장비가 이미 두 대 이상 등록되어 있으면 추가하지 않음
    if (Ev_list.seq && Ev_list.seq.length >= 2) {
      alert('장비는 최대 두 대까지만 등록할 수 있습니다.');
      return; // 더 이상 추가하지 않고 함수 종료
    }
  
    const nextAddress = Ev_list.seq ? Ev_list.seq.length + 1 : 1; // 기존 센서 수에 따라 어드레스 설정
    const nextName = `엠알티표준-${nextAddress}`; // 자동으로 이름 설정
  
    // 짝수일 때는 수평/외기, 홀수일 때는 경사/표면으로 설정
    const nextSunType = nextAddress % 2 === 0 ? 1 : 0; // 1: 수평, 0: 경사
    const nextTemperatureType = nextAddress % 2 === 0 ? 1 : 0; // 1: 외기, 0: 표면
  
    const newEv = {
      commPort: inputcommPort,
      address: nextAddress.toString(), // 어드레스는 문자열로 전송
      name: nextName,
      protocol: inputProtocol,
      ethernetIp: inputcommPort === 'ETHERNET' ? inputEthernetIp : null,
      ethernetPort: inputcommPort === 'ETHERNET' ? (inputEthernetPort !== '' ? parseInt(inputEthernetPort) : null) : null,
      ev_temperatureType: nextTemperatureType,  // 짝수/홀수에 따라 표면/외기 설정
      ev_sunType: nextSunType,  // 짝수/홀수에 따라 경사/수평 설정
    };
  
    try {
      const response = await axios.post(`${config.backendUrl}/api/evs`, newEv);
      if (response.status === 201) {
        alert('환경 센서 추가 완료');
        dispatch(fetchEv_list());
  
        // 입력 필드를 다음 장비로 자동 업데이트
        const newAddress = (nextAddress + 1).toString(); // 다음 어드레스
        const newName = `엠알티표준-${nextAddress + 1}`; // 다음 이름
  
        // 다음 값을 입력 필드에 설정
        setInputAddress(newAddress);
        setInputName(newName);
  
      } else {
        console.error('환경 센서 추가 실패:', response);
      }
    } catch (error) {
      console.error('환경 센서 추가 중 오류 발생:', error);
    }
  };
  

  // 수정 버튼 클릭 시 모달에 기존 값을 로드하여 편집
  const handleEditClick = (index) => {
    setEditIndex(index);
    setcommPort(Ev_list.ev_commPort[index]);
    setInputAddress(Ev_list.ev_address[index]);
    setInputName(Ev_list.ev_name[index]);
    setInputProtocol(Ev_list.ev_protocol[index]);
    setInputEthernetIp(Ev_list.ev_ethernetIp[index]);
    setInputEthernetPort(Ev_list.ev_ethernetPort[index]);
    setShowModal(true);
  };

  // 수정 사항 저장 함수 정의
  const handleSaveClick = async () => {
    const updatedEv = {
      commPort: inputcommPort,
      address: inputAddress,
      name: inputName,
      protocol: inputProtocol,
      ethernetIp: inputcommPort === 'ETHERNET' ? inputEthernetIp : null,
      ethernetPort: inputcommPort === 'ETHERNET' ? (inputEthernetPort !== '' ? parseInt(inputEthernetPort) : null) : null,
      ev_temperatureType: Ev_list.ev_temperatureType[editIndex],  // 리덕스 스토어에서 값 가져오기
      ev_sunType: Ev_list.ev_sunType[editIndex],  // 리덕스 스토어에서 값 가져오기
    };

    try {
      const response = await axios.put(`${config.backendUrl}/api/update_ev/${Ev_list.seq[editIndex]}`, updatedEv);
      if (response.status === 200) {
        console.log(`장비 ${editIndex + 1} 업데이트 완료`);
        dispatch(fetchEv_list());
        setShowModal(false);  // 저장 후 모달 닫기
        alert('저장되었습니다.');  // 저장 완료 후 알림 팝업 띄우기
      } else {
        console.error(`장비 ${editIndex + 1} 업데이트 실패:`, response);
      }
    } catch (error) {
      console.error(`장비 ${editIndex + 1} 업데이트 중 오류 발생:`, error);
    }
  };

  const handleDeleteClick = (index) => {
    const confirmDelete = window.confirm('정말로 삭제하시겠습니까?');
    if (confirmDelete) {
      const seq = Ev_list.seq[index];
      axios.delete(`${config.backendUrl}/api/evs/${seq}`)
        .then(() => {
          dispatch(removeEv(index));
          alert(`${Ev_list.ev_name[index]} 삭제 완료`);
        })
        .catch(error => console.error('삭제 중 오류 발생:', error));
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center align-items-center">
        <Col md="2">
          <Form.Label>통신 포트</Form.Label>
          <Form.Control as="select" value={inputcommPort} onChange={(e) => setcommPort(e.target.value)}>
            {commPortList.map((port, index) => (
              <option key={index} value={port}>
                {port}
              </option>
            ))}
          </Form.Control>
        </Col>
        <Col md="2">
          <Form.Label>장비 ID</Form.Label>
          <Form.Control type="text" value={inputAddress} onChange={(e) => setInputAddress(e.target.value)} />
        </Col>
        <Col md="2">
          <Form.Label>이름</Form.Label>
          <Form.Control type="text" value={inputName} onChange={(e) => setInputName(e.target.value)} />
        </Col>
        <Col md="2">
          <Form.Label>프로토콜</Form.Label>
          <Form.Control as="select" value={inputProtocol} onChange={(e) => setInputProtocol(e.target.value)}>
            {sensor_protocolList.map((protocol, index) => (
              <option key={index} value={protocol}>
                {protocol}
              </option>
            ))}
          </Form.Control>
        </Col>
        {inputcommPort === 'ETHERNET' && (
          <>
            <Col md="2">
              <Form.Label>IP 주소</Form.Label>
              <Form.Control type="text" value={inputEthernetIp} onChange={(e) => setInputEthernetIp(e.target.value)} />
            </Col>
            <Col md="2">
              <Form.Label>포트</Form.Label>
              <Form.Control type="text" value={inputEthernetPort} onChange={(e) => setInputEthernetPort(e.target.value)} />
            </Col>
          </>
        )}
        <Col md="2">
          <Button className="mt-4 w-100" onClick={evAddClick}>센서 추가</Button>
        </Col>
      </Row>

      {/* 테이블 - 온도 타입과 일사량 타입 체크박스로 선택 */}
      <Table striped bordered hover className="text-center mt-4" style={{ verticalAlign: 'middle' }}>
        <thead>
          <tr>
            <th>#</th>
            <th>통신 포트</th>
            <th>장비 ID</th>
            <th>이름</th>
            <th>프로토콜</th>
            <th>온도 타입</th>
            <th>일사량 타입</th>
            <th>송신 데이터</th> {/* 송신 데이터 열 추가 */}
            <th>수신 데이터</th> {/* 수신 데이터 열 추가 */}
            <th>수정</th>
            <th>삭제</th>
          </tr>
        </thead>
        <tbody>
          {Ev_list.seq && Ev_list.seq.length > 0 ? (
            Ev_list.seq.map((seq, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{Ev_list.ev_commPort?.[index] || '-'}</td>
                <td>{Ev_list.ev_address?.[index] || '-'}</td>
                <td>{Ev_list.ev_name?.[index] || '-'}</td>
                <td>{Ev_list.ev_protocol?.[index] || '-'}</td>
                <td>
                  <Form.Check
                    type="radio"
                    label="표면"
                    checked={temperatureTypes[index] === 0}
                    onChange={() => handleTemperatureChange(index, 0)}
                  />
                  <Form.Check
                    type="radio"
                    label="외기"
                    checked={temperatureTypes[index] === 1}
                    onChange={() => handleTemperatureChange(index, 1)}
                  />
                </td>
                <td>
                  <Form.Check
                    type="radio"
                    label="경사"
                    checked={sunTypes[index] === 0}
                    onChange={() => handleSunTypeChange(index, 0)}
                  />
                  <Form.Check
                    type="radio"
                    label="수평"
                    checked={sunTypes[index] === 1}
                    onChange={() => handleSunTypeChange(index, 1)}
                  />
                </td>
                <td>{evData.sendCount[index] || '-'}</td> {/* 송신 데이터 표시 */}
                <td>{evData.receiveCount[index] || '-'}</td> {/* 수신 데이터 표시 */}
                <td>
                  <Button variant="warning" size="sm" onClick={() => handleEditClick(index)}>수정</Button>
                </td>
                <td>
                  <Button variant="danger" size="sm" onClick={() => handleDeleteClick(index)}>삭제</Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9">등록된 환경센서가 없습니다.</td>
            </tr>
          )}
        </tbody>
      </Table>

      {/* 수정 모달 */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>EV 수정</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>통신 포트</Form.Label>
              <Form.Control as="select" value={inputcommPort} onChange={(e) => setcommPort(e.target.value)} className="text-center">
                {commPortList.map((port, index) => (
                  <option key={index} value={port}>
                    {port}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            {inputcommPort === 'ETHERNET' && (
              <>
                <Form.Group>
                  <Form.Label>IP 주소</Form.Label>
                  <Form.Control
                    type="text"
                    value={inputEthernetIp}
                    onChange={(e) => setInputEthernetIp(e.target.value)}
                    placeholder="192.168.0.101"
                    className="text-center"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>포트</Form.Label>
                  <Form.Control
                    type="text"
                    value={inputEthernetPort}
                    onChange={(e) => setInputEthernetPort(e.target.value)}
                    placeholder="8080"
                    className="text-center"
                  />
                </Form.Group>
              </>
            )}
            <Form.Group>
              <Form.Label>장비 ID</Form.Label>
              <Form.Control
                type="text"
                value={inputAddress}
                onChange={(e) => setInputAddress(e.target.value)}
                className="text-center"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>이름</Form.Label>
              <Form.Control
                type="text"
                value={inputName}
                onChange={(e) => setInputName(e.target.value)}
                className="text-center"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>프로토콜</Form.Label>
              <Form.Control as="select" value={inputProtocol} onChange={(e) => setInputProtocol(e.target.value)} className="text-center">
                {sensor_protocolList.map((protocol, index) => (
                  <option key={index} value={protocol}>
                    {protocol}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>취소</Button>
          <Button variant="primary" onClick={handleSaveClick}>저장</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default EnvironmentSetting;
